var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{staticClass:"mt-4",attrs:{"size":"60","width":"12","color":"primary","indeterminate":""}}),_c('div',{staticClass:"text-center mb-4",staticStyle:{"width":"100%","color":"gray"}},[_vm._v(" Preparando plataforma... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }